import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';
import { useSignup } from '../../../contexts/SignupContext';

const DEMO_MOBILE_OTP = '123456';
const DEMO_OTP_TOKEN = 'demo-mobile-otp-token';

const SignupMobile = () => {
  const navigate = useNavigate();
  const { updateSignupState } = useSignup();
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);

  const handleBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/login');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (mobile.trim().length !== 10) {
      toast.error('Please enter a valid 10-digit mobile number');
      return;
    }

    setLoading(true);

    updateSignupState({
      mobile: mobile.trim(),
      mobileOtp: DEMO_MOBILE_OTP,
      otpToken: DEMO_OTP_TOKEN,
      otpVerified: false,
    });

    toast.success('OTP sent successfully');
    toast.info(`Demo OTP is ${DEMO_MOBILE_OTP}.`);
    navigate('/signup/otp');
    setLoading(false);
  };

  return (
    <AuthLayout
      title="Create account"
      subtitle="Enter your mobile number to start registration"
      onBack={handleBack}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Mobile Number</label>
          <input
            type="tel"
            className="form-input"
            maxLength={10}
            value={mobile}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setMobile(value);
            }}
            placeholder="Enter mobile number"
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupMobile;


